import { render, staticRenderFns } from "./OrdersFliter.vue?vue&type=template&id=117f6302&"
import script from "./OrdersFliter.vue?vue&type=script&lang=js&"
export * from "./OrdersFliter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports